import { getTranslatableValue } from '@/utils/translatable-field/getTranslatableValue';
import { useQuestionView } from '../context/QuestionViewContext';
import { BuilderComposite, QuestionDirector, QuestionViewProps } from '../types';
import { QuestionTypeEnum } from '@/models/Question';

export function createDirector(builder: BuilderComposite): QuestionDirector {
  function Director(props: QuestionViewProps) {
    const { language } = useQuestionView();
    const { Base, Title, Context, Answer } = builder;
    const { question } = props;

    return (
      <Base>
        <Title title={getTranslatableValue(question.title, language)} />
        <Context context={getTranslatableValue(question.context, language)} />
        {question.type !== QuestionTypeEnum.TEXT &&  <Answer {...props} />}
      </Base>
    );
  }

  return Director;
}
